'use client';

import { Radio } from '@base-ui/react/radio';
import cn from 'classnames';
import type { ComponentProps } from 'react';

import styles from './SwdRadio.module.scss';

export type SwdRadioProps = ComponentProps<typeof Radio.Root>;

export function SwdRadio({ className, ...props }: SwdRadioProps) {
  return (
    <Radio.Root className={cn(styles.radio, className)} {...props} data-slot="radio">
      <span className={styles.indicator} data-slot="radio-indicator" aria-hidden="true">
        <span className={styles.dot} />
      </span>
    </Radio.Root>
  );
}
